import React from 'react';
import { Box, Button, Text, VStack, Wrap, WrapItem } from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { Number } from '../../common/Format/Number';
import { Link } from 'react-router-dom';
import { SingleObject } from '../../../types/ObjectTypes';
import { ObjectParams, ObjectsParams } from '../../../types/ParamsTypes';
import {
  getExtendedObjectRoute,
  getSimpleObjectRoute,
  isQualifiedToFetchWithExtendedParams,
} from '../../../services/Object/ObjectService';
import { getPriceDetailsText, getPriceAdText } from '../../../services/Objects/priceCtaText';

export interface PriceAndCtaProps {
  object: SingleObject;
  objectsParams: ObjectsParams | ObjectParams;
}

export const PriceAndCta = (props: PriceAndCtaProps): JSX.Element => {
  const { object, objectsParams } = props;
  const objectPrice = object.priceData?.COMMON;

  return (
    <Wrap alignSelf={'stretch'} flexWrap={'wrap'} justify={'space-between'}>
      <WrapItem>
        <Box mr={8} width={'100%'}>
          <VStack spacing={0} alignItems={'flex-start'}>
            {!object.baseData.DisableOnlinePriceCalculation &&
              <>
                {objectPrice?.advertisingData
                  ? <>
                    <Text fontSize={'xl'} textColor={'green.400'} fontWeight={'bold'}>
                      ab{' '}
                      {
                        <Number
                          number={objectPrice.advertisingData.dayPrice}
                          locales={'de-De'}
                          style={'currency'}
                          currency={'EUR'}
                        />
                      }
                      {' '}/ Tag
                    </Text>
                    <Text fontSize={'xs'} as={'i'} color={'gray.400'}>
                      {getPriceAdText(objectPrice.advertisingData.numberOfDays, objectPrice.advertisingData.numberOfPersons, objectsParams)}
                    </Text>
                  </>
                  : <>
                    <Text fontSize={'xl'} textColor={'green.400'} fontWeight={'bold'}>
                      ab{' '}
                      {
                        <Number
                          number={object.priceData?.COMMON.totalPrice}
                          locales={'de-De'}
                          style={'currency'}
                          currency={'EUR'}
                        />
                      }
                    </Text>
                    <Text fontSize={'xs'} as={'i'} color={'gray.400'}>
                      {getPriceDetailsText(object.priceData?.RENTAL.numberOfDays, objectsParams)}
                    </Text>
                  </>
                }
              </>
            }
          </VStack>
        </Box>
      </WrapItem>
      <WrapItem>
        <Box>
          <Link
            to={{
              pathname: isQualifiedToFetchWithExtendedParams({
                id: object.baseData.uniqueId,
                fromDate: objectsParams.fromDate,
                toDate: objectsParams.toDate,
              })
                ? getExtendedObjectRoute(object, objectsParams)
                : getSimpleObjectRoute(object, objectsParams),
            }}
            target="_blank"
            style={{ width: '100%' }}>
            <Button rightIcon={<ArrowForwardIcon />} variant="primary">
              Details
            </Button>
          </Link>
        </Box>
      </WrapItem>
    </Wrap>
  );
};
